/*
 * Matevara — Hero viewport fill
 * Measures the live header chrome height (announcement bar + sticky Ella header)
 * and exposes it as --fs-header-h on :root, so the hero can fill exactly
 * 100svh minus the chrome via calc(). Recomputed on resize and whenever the
 * header re-lays-out (sticky shrink, announcement close, font load, etc.).
 *
 * Ella sticky header uses `#header-group { display: contents }`, so the
 * group element itself reports height 0. We measure the rendered header
 * sections instead and take their combined top-of-page footprint.
 */
(function () {
  var root = document.documentElement;

  function chromeHeight() {
    var group = document.getElementById('header-group');
    if (!group) return 0;

    // display:contents on the group → measure its laid-out children instead.
    var h = 0;
    var kids = group.children;
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      // Skip elements taken out of normal flow — fixed/absolute mega-menu
      // dropdown panels (.fs-mega) live inside #header-group but are
      // position:fixed + visibility:hidden until hovered. They still report
      // a getBoundingClientRect() height (600px+), which wrongly inflated
      // --fs-header-h to ~887px and forced a hero resize → CLS on load.
      // Only real top chrome (announcement + header + nav = ~152px) counts.
      var cs = window.getComputedStyle(el);
      if (cs.position === 'fixed' || cs.position === 'absolute') continue;
      if (cs.display === 'none' || cs.visibility === 'hidden') continue;
      var rect = el.getBoundingClientRect();
      // Only count chrome sitting at the top of the page (above the fold),
      // i.e. its top is at/near viewport top on initial load.
      h += rect.height;
    }
    return Math.round(h);
  }

  function update() {
    // Only relevant when the hero is the first section (homepage).
    var hero = document.querySelector('.fs-hero');
    if (!hero) return;
    root.style.setProperty('--fs-header-h', chromeHeight() + 'px');
  }

  // Initial + after full load (images/fonts can change header height).
  update();
  window.addEventListener('load', update);

  // Recompute on viewport resize / orientation change.
  var raf;
  window.addEventListener('resize', function () {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(update);
  });

  // Track header relayout (sticky transitions, announcement dismiss, etc.).
  if ('ResizeObserver' in window) {
    var group = document.getElementById('header-group');
    if (group) {
      var ro = new ResizeObserver(function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(update);
      });
      // Observe the rendered children (group itself is display:contents).
      for (var i = 0; i < group.children.length; i++) ro.observe(group.children[i]);
    }
  }
})();
